import React from 'react';
import { ThemeProvider } from './components/styles/ThemeContext';
import { InteriorViewer } from './components/Interior/InteriorViewer';
export function App() {
  return <ThemeProvider data-id="element-0">
      <InteriorViewer data-id="element-1" />
    </ThemeProvider>;
}